const filterPaymentProviders = (paymentProviders, accepted) =>
  paymentProviders.filter((provider) => accepted.includes(provider.name));

const filterProducts = (products, context) => {
  if (context.product_type == 'early_bird') {
    products = products.filter(
      (product) =>
        product.name != '6 months' &&
        product.name != '1 year' &&
        product.name != '2 day taster',
    );
  }
  products = products.filter((product) => product.name != '2 day taster');
  return products;
};

const dataFilter = (
  staticData,
  products,
  paymentProviders,
  discounts,
  cart,
  context,
  pageData,
  acceptedPaymentProviders,
) => {
  const filteredPaymentProviders = filterPaymentProviders(
    paymentProviders,
    acceptedPaymentProviders,
  );
  const filteredProducts = filterProducts(products.personal, context);

  return {
    staticData,
    products: filteredProducts,
    paymentProviders: filteredPaymentProviders,
    discounts,
    checkoutCart: cart,
    context,
    pageData,
  };
};

export default dataFilter;
